export default "https://cdn-static.gokick.com/assets/0205635f2685a00e1fdcb9112c4ac213a84703ca/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";